/** The server rejects longer captions on every attachment write path. */
export const ATTACHMENT_CAPTION_MAX_LENGTH = 500;
